import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const EnteredChart = ({ data }) => {
	const { t } = useTranslation();
	const dataCopy = [...data];
	const sortedData = dataCopy.length
		? dataCopy.sort((a, b) => b.entered - a.entered)
		: [];
	const highestValue = sortedData.length && sortedData[0].entered;

	return (
		<Box>
			<Box
				sx={{ background: "#000", color: "#fff", mb: "18px", p: "6px 14px" }}
			>
				{t("entered")} &mdash; {t("top_relations")}
			</Box>
			{sortedData.length ? (
				<Box
					sx={{ maxHeight: "780px", overflowY: "scroll", paddingRight: "30px" }}
				>
					<Row>
						<RelationCell></RelationCell>
						<TitleCell>{t("entered_1")}</TitleCell>
					</Row>
					{sortedData.map((d) => {
						return (
							<Row key={`chart-entered-row-${d.relation}`}>
								<RelationCell>{d.relation}</RelationCell>
								<ValueCell value={d.entered} highestValue={highestValue} />
							</Row>
						);
					})}
				</Box>
			) : (
				<Box sx={{ textAlign: "center", mt: "20px;" }}>{t("no_cargos")}</Box>
			)}
		</Box>
	);
};

export default EnteredChart;

const Row = (props) => <Box sx={{ display: "flex" }}>{props.children}</Box>;

const RelationCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 32%", p: "0 2px" }}>
		{props.children}
	</Box>
);

const TitleCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 68%", p: "0 2px" }}>
		{props.children}
	</Box>
);

const ValueCell = ({ value, highestValue }) => (
	<Box
		sx={{
			border: "1px solid #BFBFBF",
			flex: "0 0 68%",
			color: "#000",
			position: "relative",
			"&:before": {
				content: "''",
				position: "absolute",
				left: 0,
				top: 0,
				background: "#aba6a6",
				height: "100%",
				width: `calc(${value} * 100% / ${highestValue})`,
				zIndex: "1",
			},
		}}
	>
		<Box sx={{ position: "relative", zIndex: "100", p: "0 2px" }}>{value}</Box>
	</Box>
);
